import { IndorImages, getIndorImageSrc } from "../../../features";
import { highlightSearchValueInText } from "../../../features/textHighlighter/textHighlighter";

const roadIconSrc = getIndorImageSrc(IndorImages.Road);
const geomarkerIconSrc = getIndorImageSrc(IndorImages.Geomarker);

export default function MapSearchbarResult({ searchResult, onClick, onKeyDown, focused, index, searchValue }: any) {

    const searchResultIsPath = !!searchResult?.PathID
    let searchResultName = ''
    let resultTypeImageSrc = null
    if (searchResultIsPath) {
        const { Name, RoadName } = searchResult ?? {}
        searchResultName = `${RoadName ?? ''} ${Name ?? ''}`.trim()
        resultTypeImageSrc = roadIconSrc
    } else {
        searchResultName = searchResult?.name
        resultTypeImageSrc = geomarkerIconSrc
    }

    return (
        <div tabIndex={index} id={(focused ? 'map-searchbar-item-focused' : '')} className="map-searchbar-result" onClick={onClick} onKeyDown={onKeyDown}>
            <img className="result-type-image" alt="Тип результата поиска" src={resultTypeImageSrc} />
            <span className="result-name">{highlightSearchValueInText(searchResultName, searchValue)}</span>
        </div>
    )
}
